export default "__VITE_ASSET__CEumtVr1__"